import { useTranslation } from "react-i18next";
import i18n from "../config/i18n";

export const useLocalizedTranslation = (lng, ns = "common") => {
  const activeLanguage = lng ?? i18n.language;

  // ⚠️ This will suspend if translations aren't loaded yet!
  return useTranslation(ns, { lng: activeLanguage });
};
